import { render, staticRenderFns } from "./TableCellRecruiters.vue?vue&type=template&id=fdf9b8f8&"
import script from "./TableCellRecruiters.vue?vue&type=script&lang=js&"
export * from "./TableCellRecruiters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports